import React, { Component } from "react";
import { Link } from 'react-router-dom';

export class SuccessfullPage extends Component {
  get emails() {
    const successData = this.props.successData;
    return successData.pastors.edges.map(edges => edges.node.email).concat([successData.seniorPastor.email]);
  }

  render() {
    return (
      <div>
        <div className="m-24">
          <p>Church profile is created</p>
          <p>Church code is {this.props.successData.code}</p>
          <p>Confirmation emails were sent to:</p>
          <ul>
            {
              this.emails.map((email, index) => {
                return <li key={index}>{email}</li>
              })
            }
          </ul>

          <Link to="/dashboard/admin/churches">GO TO CHURCH LIST</Link>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/churches/successfullPage.js